// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckoutForm-m_u8kSxE3GU_erQpLzpIBf {
    display: flex;
    justify-content: right;
}

.CheckoutForm-m_pcgG7ojOk5Jgt7zB317b {
    float: right;
    margin-top: 1rem;
    margin-left: 0;
}

.CheckoutForm-m_hxbzekDBpG0RjGVo7HcG {
    margin-top: 1rem;
    font-size: 0.9rem;
    font-style: italic;
}

.CheckoutForm-m_HpZNQxzARxylSuKyrpC7 div {
    font-size: 1.5rem;
    margin-right: 1rem;
}

.CheckoutForm-m_vUceYyQQacPxAupvihyG {
    border: 1px solid var(--error-foreground);
    background-color: var(--error-background);
    color: var(--error-foreground);
    padding: 1rem;
    margin: 1rem 0;

    display: flex;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./client/shared/CheckoutForm/CheckoutForm.m.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,yCAAyC;IACzC,8BAA8B;IAC9B,aAAa;IACb,cAAc;;IAEd,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".buttonContainer {\n    display: flex;\n    justify-content: right;\n}\n\n.payButton {\n    float: right;\n    margin-top: 1rem;\n    margin-left: 0;\n}\n\n.linkMessage {\n    margin-top: 1rem;\n    font-size: 0.9rem;\n    font-style: italic;\n}\n\n.errorIcon div {\n    font-size: 1.5rem;\n    margin-right: 1rem;\n}\n\n.errorMessage {\n    border: 1px solid var(--error-foreground);\n    background-color: var(--error-background);\n    color: var(--error-foreground);\n    padding: 1rem;\n    margin: 1rem 0;\n\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
export var buttonContainer = `CheckoutForm-m_u8kSxE3GU_erQpLzpIBf`;
export var payButton = `CheckoutForm-m_pcgG7ojOk5Jgt7zB317b`;
export var linkMessage = `CheckoutForm-m_hxbzekDBpG0RjGVo7HcG`;
export var errorIcon = `CheckoutForm-m_HpZNQxzARxylSuKyrpC7`;
export var errorMessage = `CheckoutForm-m_vUceYyQQacPxAupvihyG`;
export default ___CSS_LOADER_EXPORT___;
